export default "__VITE_ASSET__K0XYbv5o__"